import underConstructionImg from "@/assets/under-construction.png";

const UnderConstructionSvg = () => {
  return (
    <div className="relative w-full max-w-xs mx-auto">
      <style>{`
        @keyframes light-glow {
          0%, 100% {
            background: #cc2222;
            box-shadow: 0 0 4px rgba(204, 34, 34, 0.5);
          }
          50% {
            background: #ff4444;
            box-shadow: 0 0 12px rgba(255, 68, 68, 0.9);
          }
        }
        .uc-light-dot {
          position: absolute;
          width: 12px;
          height: 12px;
          border-radius: 50%;
          animation: light-glow 1.5s ease-in-out infinite;
        }
        .uc-light-dot-2 {
          animation-delay: 0.75s;
        }
      `}</style>
      <img
        src={underConstructionImg}
        alt="Under Construction"
        className="w-full h-auto"
      />
      {/* Red glowing lights on the barricade */}
      <div className="uc-light-dot" style={{ left: '27%', top: '61%' }} />
      <div className="uc-light-dot uc-light-dot-2" style={{ left: '37%', top: '61%' }} />
    </div>
  );
};

export default UnderConstructionSvg;
